// Stepper — 7-step progress with validation gating (F12.1). Presentation.

import { Check } from 'lucide-react';
import { useStore, useBuilderStep, useActiveValuation } from '../../store/selectors';
import { computeStepValidation } from '../../store';

const STEP_LABELS = [
  'Setup & Dates',
  'Cap Table',
  'Equity Value & Anchor',
  'Methodology',
  'Assumptions',
  'Discounts',
  'Run',
];

export function Stepper() {
  const { currentStep, completedSteps } = useBuilderStep();
  const gotoStep = useStore((s) => s.gotoStep);
  const active = useActiveValuation();

  return (
    <nav className="stepper" aria-label="Valuation builder steps">
      {STEP_LABELS.map((label, i) => {
        const step = i + 1;
        const validation = computeStepValidation(step, active);
        const isActive = step === currentStep;
        const isCompleted = completedSteps.includes(step);
        const canJump = step <= currentStep || validation.valid;
        return (
          <button
            key={step}
            type="button"
            className={`step-item ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
            onClick={() => gotoStep(step)}
            disabled={!canJump}
            aria-current={isActive ? 'step' : undefined}
          >
            <span className="step-number" aria-hidden="true">
              {isCompleted ? <Check size={12} strokeWidth={3} /> : step}
            </span>
            <span>{label}</span>
            {!validation.valid && step === currentStep && (
              <span className="badge badge-error" title={validation.blockingIssues.join(', ')}>
                !
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
